import { ENV } from '@/shared/config'

export const isMobileApp = ENV.PLATFORM === 'mobile'
